var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_293_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4783 11.1739H13V28.8261H18.4783V11.1739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 11.1739H21.5217V28.8261H27V11.1739Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_293_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17.6522,
    fill: "white",
    transform: "translate(13 11.1739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNew);
export default __webpack_public_path__ + "static/media/pause-new.889aa7dcd1d698c11af96e132706ac6f.svg";
export { ForwardRef as ReactComponent };